import React from 'react';

// Components
import FichaInfracao from '../../FichaInfracao';

export default function ItemFichaInfracao({ infracaoId, onReady }) {
    return <FichaInfracao impressaoPDFDividaAtiva={{ infracao_id: infracaoId }} onCarregado={onReady} />;
}
